import { render } from "./InputGift.vue?vue&type=template&id=77e52377&scoped=true"
import script from "./InputGift.vue?vue&type=script&lang=js"
export * from "./InputGift.vue?vue&type=script&lang=js"

import "./InputGift.vue?vue&type=style&index=0&id=77e52377&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e52377"]])

export default __exports__